/* Built In Imports */
import { useContext, useEffect } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import Breadcrum from '@components/Navigation/Breadcrum';
import VolunteerCommonUI from '@components/UI/Volunteer/VolunteerCommonUI';
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import WrapLayout from '@Layout/WrapLayout';
import { AuthContext } from '@store/auth-context';

/* Services */
import { getLocale } from '@components/Utility/Shared/SharedService';
import {
  fetchFooterData,
  fetchHeaderMenuData,
  fetchHeaderTopMenuData
} from 'services/commonService';
import { fetchDetails, getLandingPaths } from 'services/volunteerService';
import { usePathname } from 'next/navigation';

/* Styles */

/**
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} pageData - VolunteerProgram Page Data
 */
const VolunteerProgram = ({ region, language, pageData }) => {
  const authContext = useContext(AuthContext);
  const pathname = usePathname();

  useEffect(() => {
    authContext.RegionAndLang(region, language);
  }, [authContext, region, language]);

  // consoleLog('page', pageData);
  return (
    <WrapLayout>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData?.availableLocales}
      >
        {' '}
      </HeadComponent>
      <Breadcrum
        page={pageData?.breadcrumbs}
        alsoin={pageData?.alsoin}
        url=""
        region={region}
        lang={language}
        pageConfig={pageData?.pageConfig}
      />
      <Box as="section" className={`container-article ${!pathname?.endsWith(`/volunteer/sadhguru-sahabhagi`) && "page-wrap"}`} padding="0">
        <VolunteerCommonUI
          pageBody={pageData?.body}
          region={region}
          lang={language}
        />
        <style>
          {`
            .content-area{
              max-width:570px !important;
            }
            `}
        </style>
      </Box>
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  const volunteerLandingPaths = config.USE_LOCAL_URL
    ? [
      `/in/en/volunteer/devi-seva`,
      `/in/en/volunteer/program-event-based-volunteering`,
      `/in/en/volunteer/ashram-volunteering`,
      `/in/en/volunteer/linga-seva`,
      `/in/en/volunteer/remote-volunteering`,
      `/in/en/volunteer/adiyogi-arpanam`,
      `/in/en/volunteer/sadhguru-sahabhagi`,
    ]
    : await getLandingPaths('L1', '/volunteer/');
  return {
    paths: volunteerLandingPaths,
    fallback: false,
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { region, language, program },
  req,
}) => {
  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale(region, language),
    'isotopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale(region, language),
    'isomainmenu'
  );
  const footerData = await fetchFooterData(
    getLocale(region, language),
    'isofooter'
  );
  const pageData = await fetchDetails(region, language, `${program}`, { preview, data: previewData });

  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region: region,
      language: language,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      isPreview: preview ? true : false
    }
  };
};

export default VolunteerProgram;
